import React, { useContext } from 'react';

import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { getCurrencySymbolFromOptions } from 'Details/utils';
import { getFormattedSpendWithSymbol } from 'utils/number';
import { getTopVendorForApLibrary } from 'utils/apiRequests';
import {
	TableWrapper,
	StyledModal,
	HeaderCell,
	HeaderCellNumber,
	Cell,
	CellNumber,
	Row,
	Text,
	Title,
	LoadingContainer,
} from './TopVendorsModal.styles';

export class TopVendorsModal extends React.Component {
	state = { data: null, isLoading: true };

	componentDidMount() {
		this.fetchData();
	}

	fetchData = () => {
		const { topVendorsModalData } = this.props;
		const request = getTopVendorForApLibrary(topVendorsModalData);

		return request.then(response => {
			this.setState({ data: response.data, isLoading: false });
		});
	};

	spendFormatter = value => {
		const { currencySymbol, hideDecimals } = this.props;

		return value
			? getFormattedSpendWithSymbol(
					value,
					currencySymbol,
					hideDecimals
			  ).toUpperCase()
			: '-';
	};

	render() {
		const { onClose, topVendorsModalData } = this.props;
		const { data, isLoading } = this.state;

		return (
			<StyledModal
				isOpen={true}
				header="Top vendors"
				isDismissible
				hasClosed={onClose}
			>
				<TableWrapper>
					<Title>{topVendorsModalData.categoryName}</Title>
					{isLoading ? (
						<LoadingContainer>
							<ApLoaderDefault loaderText={() => <ApLoaderText />} />
						</LoadingContainer>
					) : data ? (
						<React.Fragment>
							<Row>
								<HeaderCell>
									<Text>Rank</Text>
								</HeaderCell>
								<HeaderCell>
									<Text>Vendor name</Text>
								</HeaderCell>
								<HeaderCellNumber>Spend</HeaderCellNumber>
							</Row>
							{data.map(({ vendorName, spend }, index) => (
								<Row key={index}>
									<Cell>
										<Text bold>{index + 1}</Text>
									</Cell>
									<Cell>
										<Text>{vendorName}</Text>
									</Cell>
									<CellNumber>{this.spendFormatter(spend)}</CellNumber>
								</Row>
							))}
						</React.Fragment>
					) : (
						<>No Data</>
					)}
				</TableWrapper>
			</StyledModal>
		);
	}
}

export default props => {
	const { currency } = useContext(QueryStringContext);
	const {
		options: { currency: currencyList },
	} = useContext(SettingsOptionsContext);
	const currencySymbol = getCurrencySymbolFromOptions(currencyList, currency);

	return (
		<TopVendorsModal
			currencySymbol={currencySymbol}
			currency={currency}
			{...props}
		/>
	);
};
